// Reference-counted body scroll lock so multiple independent overlays (mobile nav,
// modals, ISI, third-party widgets) can request/release a lock without one owner's
// cleanup wiping out another's, or a stuck lock surviving after all owners release it.
const activeLocks = new Set();

function applyLockStyles() {
  const body = document.body.style;
  // Skip no-op writes: a MutationObserver watching body's style attribute (used to
  // detect third-party scripts re-applying a stuck lock) would otherwise re-fire
  // forever on writes that don't actually change anything.
  if (body.position === 'sticky' && body.height === '100%' && body.overflow === 'hidden') return;
  body.position = 'sticky';
  body.height = '100%';
  body.overflow = 'hidden';
}

function clearLockStyles() {
  const body = document.body.style;
  if (!body.position && !body.height && !body.overflow) return;
  body.position = '';
  body.height = '';
  body.overflow = '';
}

export function lockScroll(id) {
  if (typeof document === 'undefined') return;
  activeLocks.add(id);
  applyLockStyles();
}

export function unlockScroll(id) {
  if (typeof document === 'undefined') return;
  activeLocks.delete(id);
  if (activeLocks.size === 0) {
    clearLockStyles();
  }
}
